import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

export type CountChipProps = {
  children: React.ReactNode;
  className?: string;
  title?: string;
};

/**
 * Small bordered tabular count chip (e.g. Accordion `headerAction`: "12 lines").
 */
export function CountChip({ children, className, title }: CountChipProps) {
  const { colors } = useTheme();

  return (
    <span
      title={title}
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium tabular-nums',
        colors.border,
        colors.textSecondary,
        className,
      )}
    >
      {children}
    </span>
  );
}

export default CountChip;
